import { ReactComponent as SVGLogo } from 'assets/svg/snapbar-logo.svg';

const Logo = (props) => {
  return <SVGLogo {...props} />;
};

export default Logo;
